<script setup>
const props = defineProps({
  images: { type: Array, default: () => ([]) },
})

const {setImages, openLightbox, closeLightbox} = useLightbox()

onMounted(() => {
  if (props.images?.length) setImages(props.images)
})

const carouselRef = ref()
const currentSlide = ref(0);

const onClickPagination = (n) => currentSlide.value = n - 1

const carouselConfig = {
  height: 400,
  itemsToShow: 1.3,
  wrapAround: true,
  gap: 10,
  breakpoints: {
    480: {
      gap: 15,
      height: 400,
      itemsToShow: 1.3,
    },
    768: {
      gap: 15,
      height: 300,
      itemsToShow: 1.8,
    },
    1024: {
      gap: 15,
      height: 400,
      itemsToShow: 4.5,
    }
  }
}
</script>

<template>
  <div v-if="images?.length" class="relative w-full">
    <div
      v-if="images?.length === 1"
      class="max-h-[400px] md:max-h-[500px] aspect-4/3 mx-auto"
    >
      <NuxtImg
        v-for="(img, i) of images" :key="i"
        class="max-w-full max-h-full w-full mx-auto"
        :src="img"
        :style="{
          objectFit: 'contain',
          objectPosition: 'center',
        }"
        @click="() => openLightbox(i)"
      />
    </div>

    <template v-else>
      <Carousel
        ref="carouselRef"
        v-model="currentSlide"
        class="mx-auto"
        v-bind="carouselConfig"
      >
        <Slide
          v-for="(img, i) of images"
          :key="i"
        >
          <NuxtImg
            class="h-full w-full mx-auto object-cover object-center rounded-xl"
            :src="img"
            @click="() => openLightbox(i)"
          />
        </Slide>
      </Carousel>

      <div class="max-w-[1100px] z-20 w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 flex justify-between">
        <button
          type="button"
          class="text-[#7dbc80]"
          @click="carouselRef.prev()"
        ><icon icon="mdi:triangle" class="-rotate-90" width="30" /></button>
        <button
          type="button"
          class="text-[#7dbc80]"
          @click="carouselRef.next()"
        ><icon icon="mdi:triangle" class="rotate-90" width="30" /></button>
      </div>

      <div
        v-if="images?.length"
        class="flex items-center justify-center gap-x-2 mt-3 mb-6"
      >
        <button
          v-for="n in (images?.length || 0)"
          type="button"
          class="border border-[#7dbc80] rounded-full w-3 h-3 block"
          :class="(n - 1) == currentSlide ? 'bg-[#7dbc80]' : 'bg-white'"
          @click="onClickPagination(n)"
        ></button>
      </div>
    </template>
  </div>
</template>